module.exports = __webpack_public_path__ + "static/media/ALevel_cie_logo.62c05624.jpg";